import Chartjs from "@stimulus-components/chartjs"

// Chart.js wrapper. Mode (brl/count) read from dataset to avoid shadowing the
// parent class's Stimulus values; drives axis + tooltip formatting.
export default class extends Chartjs {
  static values = { filename: String }

  get defaultOptions() {
    const isBrl = (this.element.dataset.chartMode || "brl") === "brl"
    const isHorizontal = (() => {
      try {
        return JSON.parse(this.element.dataset.chartOptionsValue || "{}").indexAxis === "y"
      } catch {
        return false
      }
    })()
    const numericAxis = isHorizontal ? "x" : "y"

    return {
      responsive:          true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: "top",
          labels: { boxWidth: 12, font: { size: 11 }, padding: 12 },
        },
        tooltip: {
          callbacks: {
            label: (ctx) => {
              const v = ctx.parsed[numericAxis]
              return isBrl
                ? ` ${ctx.dataset.label}: ${v?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}`
                : ` ${ctx.dataset.label}: ${v}`
            },
          },
        },
      },
      scales: {
        [numericAxis]: {
          ticks: {
            font:     { size: 11 },
            callback: (v) =>
              isBrl
                ? v.toLocaleString("pt-BR", { style: "currency", currency: "BRL", notation: "compact" })
                : v,
          },
        },
      },
    }
  }

  // this.chart is the Chart.js instance the base controller creates in
  // connect() (@stimulus-components/chartjs) — toBase64Image() is native to
  // it, so the download is entirely client-side, no server round trip.
  download() {
    const link = document.createElement("a")
    link.href = this.chart.toBase64Image()
    link.download = this.filenameValue || "grafico.png"
    link.click()
  }
}
